export const REGION_SELECT_STRINGS = {
  'title.default': 'Where is your\u00a0home?',
  'title.defaultWithState': 'Where is your\u00a0home in\n{state}?',
  'title.listing': 'Where would you like to\u00a0Belong?',
  'title.listingWithState': 'Where would you like to live in {state}?',
  'card.comingSoon': '(Coming Soon)',
  where_is_your_home_in: 'Where would you like to live in {state}?',
  other_cities: 'Other Cities',
  search: 'Search',
};
